
export default {
    name: 'ChromeSettingsIcon',
};
